import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';

const vuexPersist: any = new VuexPersist({
    key: 'beweegcoach',
    storage: window.sessionStorage
});

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        loggedIn: false,
        username: '',
        userRole: ''
    },
    mutations: {
        setLoggedIn(state) {
            state.loggedIn = true;
        },
        setLoggedOut(state) {
            state.loggedIn = false;
        },
        setUsername(state, value: string) {
            state.username = value;
        },
        setUserRole(state, value: string) {
            state.userRole = value;
        }
    },
    actions: {
        setLoggedIn(context) {
            context.commit('setLoggedIn');
        },
        setLoggedOut(context) {
            context.commit('setLoggedOut');
        },
        setUsername(context, value: string) {
            context.commit('setUsername', value);
        },
        setUserRole(context, value: string) {
            context.commit('setUserRole', value);
        }
    },
    modules: {
    },
    plugins:[vuexPersist.plugin]
});
